import React, { useState } from "react";
import { Toast } from "../services/toast-service";
import { Auth } from "aws-amplify";
import { useNavigate, Link } from "react-router-dom";

type ConfirmationScreenProps = {};

const ConfirmationScreen: React.FC<ConfirmationScreenProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await Auth.confirmSignUp(email, code);
      Toast("Success!!", "Verified Successfully", "success");
      navigate("/signin");
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        Toast("Error!!", err.message, "danger");
      } else {
        Toast("Error!!", "Something went wrong during confirmation.", "danger");
      }
    }
    setLoading(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === "email") {
      setEmail(value);
    } else if (name === "code") {
      setCode(value);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1>Verify Your Account</h1>
      <input
        placeholder="Email"
        type="email"
        name="email"
        value={email}
        onChange={handleInputChange}
      />
      <input
        placeholder="Code"
        type="text"
        name="code"
        value={code}
        onChange={handleInputChange}
      />
      <button disabled={loading}>
        {loading && <span>loading</span>}
        Verify your account
      </button>
      <Link to="/signup">make an account &rarr;</Link>
    </form>
  );
};

export default ConfirmationScreen;
